import AbstractRequest from './abstract'

export default class RestRequest extends AbstractRequest {
	/**
	 * ­@constructor
	 * @param {object} service - Ravello service
	 */
	constructor(service) {
		super()

		this._service = service
		this._version = 'v1'
		this._endpoint = []
	}

	/**
	 * Set route version
	 * @param {number|string} version - Route version
	 * @return {object} - This
	 */
	v(version) {
		this._version = `v${version}`
		return this
	}

	/**
	 * Set route version as temporary route
	 * @return {object} - This
	 */
	tmp() {
		this._version = 'tmp'
		return this
	}

	/**
	 * Add route node to endpoint
	 * @param {string} node - Path node
	 * @return {object} - This
	 */
	to(node) {
		this._endpoint.push(node)
		return this
	}

	/**
	 * Start the route at the me endpoint
	 */
	me() {
		this._endpoint.push('me')
		return this
	}

	/**
	 * Get path from endpoint array
	 * @param {array} suffixes - Suffixed to append
	 * @return {string} - Path
	 */
	_getPath(suffixes = []) {
		return `/${this._version}/${[...this._endpoint, ...suffixes].join('/')}`
	}

	/**
	 * Get requested report
	 * @return {object|array} - Response
	 */
	async report(comparative = false) {
		return this._service.get(
			this._getPath(),
			this._service.buildReportParams(this._params, comparative),
		)
	}

	/**
	 * Get requested data
	 * @return {object|array} - Response
	 */
	async get() {
		return this._service.get(this._getPath(), this._params)
	}

	/**
	 * Update requested data
	 * @return {object|array} - Response
	 */
	async update(data) {
		return this._service.put(this._getPath(), data)
	}

	/**
	 * Upsert requested data
	 * @return {array} - Response
	 */
	async upsert(data) {
		return this._service.put(this._getPath(['upsert']), data)
	}

	/**
	 * Create requested data
	 * @return {object|array} - Response
	 */
	async create(data) {
		return this._service.post(this._getPath(), data)
	}

	/**
	 * Delete requested data
	 * @return {object|array} - Response
	 */
	async delete(data = null) {
		return this._service.remove(this._getPath(), data)
	}

	/**
	 * Count requested data
	 * @return {object|array} - Response
	 */
	async count() {
		return this._service.get(this._getPath(['count']), this._params)
	}

	/**
	 * Get requested data data source
	 * @return {object|array} - Response
	 */
	async dataSource() {
		return this._service.get(this._getPath(['datasource']), this._params)
	}
}
